import React from "react";

function HowItWorks() {
  return (
    <div>
      <h1>How It Works</h1>
    </div>
  );
}

export default HowItWorks;
